import React from 'react'
// @ts-expect-error — importing js
import { Close, Check } from '@23/iconz'

import { intl } from 'lang/intl'
import { Field, Form, Formik, FormikHelpers } from 'formik'

import './PanelParticipantList.scss'

export type PanelParticipantListOption = {
  value: number
  label: string
  isSelected: boolean
}

interface PanelParticipantListProps {
  options: Array<PanelParticipantListOption>
  onSubmit?: (selectedValues: number[]) => void
  onCancelClick?: () => void
}

const PanelParticipantList = ({
  options,
  onSubmit = () => {},
  onCancelClick = () => {},
}: PanelParticipantListProps) => {
  const cancelAriaLabel = intl.formatMessage({ defaultMessage: 'Cancel' })
  const submitAriaLabel = intl.formatMessage({ defaultMessage: 'Submit' })

  const initialValues = options.reduce((acc, option) => {
    return {
      ...acc,
      [`${option.value}`]: option.isSelected,
    }
  }, {})

  type FormValues = Record<string, boolean>

  const onSubmitHandler = (
    values: FormValues,
    _: FormikHelpers<FormValues>
  ) => {
    const ids = Object.entries(values).reduce<number[]>(
      (selectedIds, [id, isSelected]) => {
        if (isSelected) {
          return [...selectedIds, +id]
        }
        return selectedIds
      },
      []
    )
    onSubmit(ids)
  }

  return (
    <Formik<FormValues>
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmitHandler}
    >
      {(_) => (
        <aside className="panel-participant-list">
          <Form>
            <header>
              <div className="panel-participant-list-title">
                {intl.formatMessage({
                  defaultMessage: 'Select Panel Speakers',
                })}
              </div>
              <div className="panel-participant-list-actions">
                <button
                  type="button"
                  className="cancel"
                  aria-label={cancelAriaLabel}
                  onClick={onCancelClick}
                >
                  <Close />
                </button>
                <button
                  type="submit"
                  className="submit"
                  aria-label={submitAriaLabel}
                >
                  <Check />
                </button>
              </div>
            </header>
            {options.map((option) => {
              const showAriaLabel = intl.formatMessage(
                {
                  defaultMessage:
                    'Press space to show or hide {name} from the panel monitor',
                },
                { name: option.label }
              )
              return (
                <div key={option.value}>
                  <label>
                    <Field
                      type="checkbox"
                      name={option.value.toString()}
                      aria-label={showAriaLabel}
                    />
                    <div className="checkbox">
                      <Check />
                    </div>
                    <p>{option.label}</p>
                  </label>
                </div>
              )
            })}
          </Form>
        </aside>
      )}
    </Formik>
  )
}

export default PanelParticipantList
